export const experience = ['React','Next','React Native', 'Redux', 'CSS (LESS, SCSS)','Styled Components','HTML 5' ]